<template>
  <v-layout justify-center class="two-column-bottom-bar">
    <slot></slot>
  </v-layout>
</template>

<script>
export default {
  name: 'TwoColumnBottomAction'
}
</script>

<style lang="stylus">
.two-column-bottom-bar {
    position absolute
    bottom: 0
    left 0
    border-top: 1px solid #EBF0F5;
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    padding: 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: var(--v-font-color-base);
    font-size: 14px;
    .link {
        color: #1abc9c;
        font-weight: bold;
        margin-left 10px
    }
}
</style>
